const customGQLApi = function() {
	const apiVersion = '2021-07'
	const customerAccessTokenLocalKey = 'customerAccessToken'
	const storefrontAPIAccessToken = '7934dd2730b3f421e62ebb4325bea1b5'
	const gqlEndpoint = function() { return window.location.origin + window.Shopify.routes.root + `api/${apiVersion}/graphql.json` }
	const defaultHeaders = {
		'Content-Type': 'application/json',
		'X-Shopify-Storefront-Access-Token': storefrontAPIAccessToken,
	}

	const loginMutation = `
		mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
			customerAccessTokenCreate(input: $input) {
				customerAccessToken {
					accessToken
					expiresAt
				}
				customerUserErrors {
					code
					field
					message
				}
			}
		}
	`;
	const updateCustomerMutation = `
		mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
			customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
				customer {
					id
				}
				userErrors {
					field
					message
				}
			}
		}
	`;
	const customerAccessTokenDeleteMutation = `
		mutation customerAccessTokenDelete($customerAccessToken: String!) {
			customerAccessTokenDelete(customerAccessToken: $customerAccessToken) {
				deletedAccessToken
				deletedCustomerAccessTokenId
				userErrors {
					field
					message
				}
			}
		}
	`;

	const fetchGQL = function(body) {
		console.log(gqlEndpoint())
		return fetch(gqlEndpoint(), {
			method: 'POST',
			headers: defaultHeaders,
			body: JSON.stringify(body),
		});
	}
	return {
		getCustomerAccessToken: async function(email, password) {
			if (!email || !password) {
				return null
			}
			const response = await fetchGQL({
				query: loginMutation,
				variables: {
					input: {
						email, password
					},
				}
			})

			const jsonResponse = await response.json();
			const cat = jsonResponse?.data?.customerAccessTokenCreate?.customerAccessToken?.accessToken ?? null
			if (cat) {
				localStorage.setItem(customerAccessTokenLocalKey, cat)
			}
			return cat;
		},
		updateCustomer: async function(firstName, lastName, email, password) {
			const accessToken = localStorage.getItem(customerAccessTokenLocalKey)
			const variables = {
				customerAccessToken: accessToken,
				customer: {
					firstName,
					lastName,
					email,
					password,
				}
			};

			const response = await fetchGQL({
				query: updateCustomerMutation,
				variables: variables
			})

			const jsonResponse = await response.json();
			return jsonResponse.data.customerUpdate;
		},
		updateCustomerMarketingSubscription: async function(acceptsMarketing) {
			const accessToken = localStorage.getItem(customerAccessTokenLocalKey)
			const variables = {
				customerAccessToken: accessToken,
				customer: {
					acceptsMarketing: acceptsMarketing
				}
			};

			const response = await fetchGQL({
				query: updateCustomerMutation,
				variables: variables
			})

			const jsonResponse = await response.json();
			return jsonResponse.data.customerUpdate;
		},
		removeCustomerAccessToken: async function() {
			const accessToken = localStorage.getItem(customerAccessTokenLocalKey)
			if (!accessToken) {
				return;
			}
			localStorage.removeItem(customerAccessTokenLocalKey);
			const response = await fetchGQL({
				query: customerAccessTokenDeleteMutation,
				variables: { customerAccessToken: accessToken }
			})
			await response.json();
		}
	}
}()
